const COLLECTION_ORDER_LIST = "COLLECTION_ORDER_LIST";
const COLLECTION_ORDER_LIST_SUCCESS = "COLLECTION_ORDER_LIST_SUCCESS";
const COLLECTION_ORDER_LIST_FAILURE = "COLLECTION_ORDER_LIST_FAILURE";
const CLEAR_COLLECTION_ORDER_LIST = "CLEAR_COLLECTION_ORDER_LIST";
const COLLECTION_ORDER_SET_SELECTED_TAB = "COLLECTION_ORDER_SET_SELECTED_TAB";

const CollectionOrderDetailSymbols = {
  COLLECTION_ORDER_LIST_SUCCESS,
  COLLECTION_ORDER_LIST_FAILURE,
  COLLECTION_ORDER_LIST,
  CLEAR_COLLECTION_ORDER_LIST,
  COLLECTION_ORDER_SET_SELECTED_TAB,
};

export default CollectionOrderDetailSymbols;
